module.exports = __webpack_public_path__ + "img/5spades.f60a9e73.jpg";